import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA,
  MatLegacyDialogRef
} from '@angular/material/legacy-dialog';
import { Field } from '@sitecore-jss/sitecore-jss/layout';

import {
  MessagesListService,
  IMessage
} from './../../../personal-archive/services/messages-list.service';
import { DialogStateService } from './../../services/dialog-state.service';

@Component({
  selector: 'ab-personal-archive-message',
  templateUrl: './personal-archive-message.component.html',
  styleUrls: ['./personal-archive-message.component.scss']
})
export class PersonalArchiveMessageComponent implements OnInit {
  public messageDetails: IMessage;
  public sender: Field;
  public date: Field;
  public delete: Field;
  public body;

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: any,
    public dialogRef: MatLegacyDialogRef<PersonalArchiveMessageComponent>,
    private messagesListService: MessagesListService,
    private dialogStateService: DialogStateService
  ) {
    this.messageDetails = this.data.data;
    this.data.fields.items.forEach((item) => {
      switch (item.name) {
        case 'Sender':
          this.sender = item.fields.label as Field;
          break;
        case 'Date':
          this.date = item.fields.label as Field;
          break;
        case 'Delete':
          this.delete = item.fields.label as Field;
          break;
        default:
          break;
      }
    });
  }

  ngOnInit() {
    this.showMessageDialog();
  }

  showMessageDialog() {
    this.body = this.messageDetails.body;
  }

  confirm() {
    this.dialogRef.close(true);
  }

  public deleteMessage() {
    this.dialogRef.close(true);
    this.dialogStateService.openDialog('ConfirmDelete').subscribe((result) => {
      if (result) {
        this.messagesListService
          .deleteMessage(this.messageDetails.id)
          .subscribe((response) => {
            if (response.callIsSuccess) {
              this.messagesListService.publishDeteledMessage(
                this.messageDetails.id
              );
            }
          });
      }
    });
  }

  public printMessage() {
    window.open(
      `${(this.data.fields.printMessageUrl as any).value.href}?id=${
        this.messageDetails.id
      }`
    );
  }
}
